import React from 'react';
import PropTypes from 'prop-types';
import { InfiniteLoader } from 'react-virtualized';

export const withInfiniteLoaderHOC = (WrappedComponent) => {
  const HOC = props => (
    <InfiniteLoader
      isRowLoaded={props.isRowLoaded}
      loadMoreRows={props.loadMoreRows}
      threshold={props.onScrollOptions.threshold}
      minimumBatchSize={props.onScrollOptions.batchSize}
      rowCount={props.rowCount}
    >
      {({ onRowsRendered, registerChild }) => (
        <WrappedComponent
          {...props}
          registerChild={registerChild}
          onRowsRendered={onRowsRendered}
        />
      )}
    </InfiniteLoader>
  );
  HOC.propTypes = {
    rowCount: PropTypes.number.isRequired,
    isRowLoaded: PropTypes.func.isRequired,
    loadMoreRows: PropTypes.func.isRequired,
    onScrollOptions: PropTypes.shape({
      batchSize: PropTypes.number.isRequired,
      threshold: PropTypes.number.isRequired,
    }).isRequired,
  };
  return HOC;
};
